export const getParams: RequestInit = {
    credentials: 'include',
    mode: 'cors'
};

let _params = (body: string): RequestInit => ({
    ...getParams,
    headers: { 'Content-Type': 'application/json' },
    body
});

export const postParams = (body: string): RequestInit => ({
    ..._params(body),
    method: "POST"
});

export const putParams = (body: string): RequestInit => ({
    ..._params(body),
    method: "PUT"
});

export const deleteParams = (body: string): RequestInit => ({
    ..._params(body),
    method: "DELETE"
});